import React, { useContext, useEffect, useState } from "react";
import coinIcon from "assets/icons/coin.svg";
import HeaderWallet from "components/layout/headers/wallet/headerWallet";
import {
  Container,
  Nodata,
  TableContainer,
  ToggleTitleContainer,
  UserInfoCash,
  WalletButtonContainer,
  WalletContainer,
  WalletForm,
  WalletFormContainer,
  WalletInfoContainer,
  WalletPayContainer,
} from "./index.styled";

import { Helmet } from "react-helmet";

import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { env } from ".env";
import { WalletValue } from "components/component-styles/buttons/index.styled";
import TransactionTable from "components/tables/tableWallet/transactionTable/TransactionTable";
import WalletModal from "components/walletModal/WalletModal";
import { UserInfoContext } from "contexts/userInfo";
import useWindowDimensions from "hooks/useWindowDimensions";
import Transactions from "services/apis/transactionsAPI";
import priceSeparator from "utils/priceSeparator/PriceSeparator";

import GiftModal from "components/giftModal/GiftModal";
import BankResult from "components/resultBank";
import Wallets from "services/apis/walletsAPI";
import rialConvertToToman from "utils/convertRialToToman/convertRialToToman";
import RootLayout from "components/layout/rootLayout";
import { numberRegex } from "utils/validate";

export default function Wallet() {
  const [charge, setCharge] = React.useState("");

  const userData = useContext(UserInfoContext);
  const dim = useWindowDimensions();
  const [giftCode, setGiftCode] = useState("");
  const [giftModal, setGiftModal] = useState(false);
  const [giftId, setGiftId] = useState();
  const [amount, setAmount] = useState();
  const [activeTitle, setActiveTitle] = useState("increaseCode");
  const submitCharge = async () => {
    if (Number(charge) >= 5000) {
      const response = await new Transactions({
        amount: charge,
      }).postTransactions();

      if (response.type) {
        window.location.href = `${env.REACT_APP_BANK_REDIRECT}${response.data.data.meta_data.RefId}`;
      } else {
        toast.warning(response.message);
      }
    } else {
      toast.warning("حداقل مبلغ باید 5000 تومان باشد.");
    }
  };

  // <handle modal

  const [showModal, setShowModal] = useState(false);
  const [submitCode, setSubmitCode] = useState(false);
  function handleModal() {
    if (charge !== "" && Number(charge) >= 5000) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }
  async function handleGiftModal() {
    if (giftCode !== "") {
      setGiftModal(true);
      const response = await new Transactions().postTransactionsGiftCode(
        giftCode
      );
      if (response.type) {
        toast.success(response.data.data);
        let giftId = response?.data?.data?.giftCodeId;
        let giftCode = response?.data?.data?.code;
        let amount = response?.data?.data?.amount;
        setAmount(amount);

        setGiftId(giftId);
        await getUsersInfo();
        setSubmitCode(true);
      } else {
        toast.error(response.message);
        setGiftModal(false);
        setGiftCode(false);
      }
    }
  }

  const submitGiftCode = async () => {
    setGiftModal(false);
  };
  const changeGiftCodeHandler = (e) => {
    setGiftCode(e.target.value);
  };
  const getUsersInfo = async () => {
    const walletResponse = await new Wallets().getWallet();

    if (walletResponse.type) {
      userData.setWalletData(walletResponse?.data.data.balance);
    }
  };

  // handle modal>
  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();
  const [isSuccessful, setIsSuccessful] = useState(false);
  let result = JSON.parse(query.get("result"));
  useEffect(() => {
    if (result === null) {
      setTransactionStatusModalShow(false);
    } else if (result.ResCode === 0) {
      setTransactionStatusModalShow(true);
      setIsSuccessful(true);
    } else {
      setTransactionStatusModalShow(true);
      setIsSuccessful(false);
    }
  }, [result]);
  // let options = { year: "numeric", month: "long", day: "numeric" };
  let today = new Date().toLocaleDateString("fa-IR");

  var current_time = new Date().getHours() + ":" + new Date().getMinutes();
  const data = {
    id: 0,
    price: "20",
    RefId: `${result?.RefId}`,
    localDate: `${today}`,
    localTime: `${current_time}`,
  };

  const [transactionStatusModalShow, setTransactionStatusModalShow] =
    useState(false);
  const [noData, setNoData] = useState(false);

  function handleNoData() {
    setNoData(true);
  }

  const walletChargeHandler = (e)=>{
    if(numberRegex(e.target.value) || e.target.value===''){
      setCharge(e.target.value)
    }
  }

  // handle no data>

  const nodataConst = (
    <Nodata>
      <h4>هیچ تراکنشی وجود ندارد.</h4>
    </Nodata>
  );
  return (
    <>
      <Helmet>
        <title>کیف پول</title>
      </Helmet>

      <RootLayout Header={HeaderWallet}>
        <Container>
          <WalletContainer>
            <WalletInfoContainer>
              {dim.width < 1025 ? (
                <h2>شماره همراه کاربر</h2>
              ) : (
                <h2>اعتبار فعلی</h2>
              )}
              {dim.width < 1025 ? (
                <div className="mobileInfo">
                  {userData.usersInfo ? userData.usersInfo.mobile : ""}{" "}
                </div>
              ) : (
                <UserInfoCash>
                  <div>
                    <img src={coinIcon} alt="icon" />
                    <span>موجودی کیف پول</span>
                  </div>
                  <div className="border"></div>

                  <WalletValue>
                    {priceSeparator(
                      rialConvertToToman(userData?.walletData?.toFixed(0))
                    )}{" "}
                    تومان{" "}
                  </WalletValue>
                </UserInfoCash>
              )}
            </WalletInfoContainer>
            <WalletPayContainer>
              <ToggleTitleContainer>
                {dim.width < 1024 ? (
                  <h2
                    className={
                      activeTitle === "increaseCode" ? "activeTitle" : ""
                    }
                    onClick={() => setActiveTitle("increaseCode")}
                  >
                    مبلغ را وارد کنید
                  </h2>
                ) : (
                  <h2
                    className={
                      activeTitle === "increaseCode" ? "activeTitle" : ""
                    }
                    onClick={() => setActiveTitle("increaseCode")}
                  >
                    افزایش اعتبار
                  </h2>
                )}
                <h2
                  className={activeTitle === "giftCode" ? "activeTitle" : ""}
                  onClick={() => setActiveTitle("giftCode")}
                >
                  کد هدیه
                </h2>
              </ToggleTitleContainer>
              {activeTitle === "giftCode" ? (
                <WalletFormContainer>
                  <WalletForm>
                    <input
                      type="text"
                      placeholder="کد هدیه را وارد کنید."
                      onChange={changeGiftCodeHandler}
                      // defaultValue={giftCode}
                      value={submitCode ? "" : giftCode}
                    />
                  </WalletForm>
                  <WalletButtonContainer>
                    <button onClick={handleGiftModal}>اعمال کد</button>
                  </WalletButtonContainer>
                </WalletFormContainer>
              ) : (
                <WalletFormContainer>
                  <WalletForm>
                    <input
                      type="string"
                      placeholder="مبلغ را وارد کنید (تومان) ..."
                      value={charge}
                      onChange={walletChargeHandler}
                    />
                  </WalletForm>
                  <WalletButtonContainer>
                    {dim.width < 1025 ? (
                      <button onClick={handleModal}>افزایش اعتبار</button>
                    ) : (
                      <button onClick={handleModal}>پرداخت</button>
                    )}
                  </WalletButtonContainer>
                </WalletFormContainer>
              )}
            </WalletPayContainer>
          </WalletContainer>
          <TableContainer>
            <h2>آخرین تراکنش ها</h2>
            {!noData && <TransactionTable handleNoData={handleNoData} />}
            {noData && nodataConst}
          </TableContainer>
        </Container>
        {showModal && (
          <WalletModal
            pay={submitCharge}
            closing={() => setShowModal(false)}
            charge={charge}
          />
        )}
        {giftModal && (
          <GiftModal
            pay={submitGiftCode}
            giftCode={giftCode}
            giftId={giftId}
            amount={amount}
          />
        )}

        {transactionStatusModalShow ? (
          <BankResult data={data} isSuccessful={isSuccessful} />
        ) : (
          ""
        )}
      </RootLayout>
    </>
  );
}
